export class MatchingAgencyField {

  static readonly MATCHING_AGENCY_ID = 'matchingAgencyId';
  static readonly PROPERTY_NAME = 'propertyName';
  static readonly PROPERTY_ID = 'propertyId';
  static readonly CREATED_DATE = 'createdDate';

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-agency-field.ts